<template>
  <batch-upload-file lob="AE" />
</template>

<script>
import batchUploadFile from '@/components/Cargo/FileUpload/batchUploadFile'
export default {
  name: 'AEBatchUploadFile',
  components: { batchUploadFile }
}
</script>

<style scoped>

</style>
